// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface PortIoConfigOut {}

export const PortIoConfigOutSerializer = {
  _fromJsonObject(_object: any): PortIoConfigOut {
    return {};
  },

  _toJsonObject(_self: PortIoConfigOut): any {
    return {};
  },
};
